import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, getAuthToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user

  useEffect(() => {
    // Vérifie la session : token (localStorage via en-tête) ou cookie même-domaine
    if (!getAuthToken()) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setAuthToken(null); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) setAuthToken(data.token);
    setUser(data);
    return data;
  };
  const register = async (name, email, password, lang = "fr") => {
    const { data } = await api.post("/auth/register", { name, email, password, lang });
    if (data.token) setAuthToken(data.token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    setAuthToken(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout }}>{children}</AuthCtx.Provider>;
}
